import { useQuery } from 'react-query';
import { TypeCustomStructuredActivityFields } from 'types/contentful/clinical';
import ContentService from 'utils/contentful/contentfulService';

export const getCustomStructuredActivity = (structuredActivityId: string) => {
  return ContentService.clients.clinical
    .getEntry<TypeCustomStructuredActivityFields>(structuredActivityId, {
      include: 10,
    })
    .then(data => data.fields as TypeCustomStructuredActivityFields);
};

export const useCustomStructuredActivity = (structuredActivityId: string) => {
  return useQuery(['custom-structured-activity', structuredActivityId], () =>
    getCustomStructuredActivity(structuredActivityId),
  );
};
